import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../../branding';
import './styles.less';
import Certificate from '../certificate';
import classNames from 'classnames';
import LearningItemActionButton from './LearningItemActionButton';
import { PaperIcon } from '@nackle/paper';
import { Translate } from '../../../services';
import StatusIcon from '../../status/Status';

const LearningListItem = ( { dataAccessor, className, isLoading } ) => {
    const theme = useContext( ThemeContext );
    const classBase = 'learning-list-item';

    return (
        <div className={ classNames( className, classBase, `${ classBase }-content`, 'tertiary', `${ classBase }-${ dataAccessor.__type }`, { locked: dataAccessor?.prerequisiteData?.locked } ) } >
            <div className='click-overlay' onClick={ dataAccessor?.onClick } />
            { theme !== 'seiko' ?
                <div className={ `image-content ${ dataAccessor?.__type } ${ dataAccessor?.tags.includes( 'SEIKO Employee HLC' ) ? 'white-bg' : '' }` }>
                    <img src={ dataAccessor?.getThumbnail( theme ) }/>
                    { dataAccessor?.prerequisiteData?.locked &&
                        <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '40px', height: '40px' } } /></div>
                    }
                </div>
                :
                <>
                    <img
                        src={ dataAccessor?.getThumbnail( theme ) }
                        maskSrc={ theme !== 'seiko' ? '/images/course-image-mask.svg' : '/images/seiko-course-image-mask.svg' }
                        className={ `${ classBase }-image` }
                        width="125"
                        height="65"
                        preserveAspectRatio="xMidYMid slice"
                    />
                    { dataAccessor?.prerequisiteData?.locked &&
                        <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '30px', height: '30px' } } /></div>
                    }

                </>
            }
            <div className={ `${ classBase }-details` }>
                <span className='locked-message line-clamp-1 _mini _subtitle'>
                { dataAccessor?.prerequisiteData?.locked && dataAccessor?.prerequisiteData?.prerequisites &&
                        <>
                            <PaperIcon collection='ultimate' icon='Lock4' />
                            { 
                                dataAccessor.__type == 'course' ? <Translate.Text value='locked.message.course'/>  
                                    : dataAccessor.__type == 'curriculum' ? <Translate.Text value='locked.message.curriculum'/> : <></>
                            }
                        </>
                    }
                </span>
                <span className={ `${ classBase }-title line-clamp-1 _title` }>
                    { dataAccessor?.displayName ?? '' }
                </span>
            </div>
            
            { dataAccessor?.hasCertificate && !dataAccessor?.prerequisiteData?.locked && <Certificate isEarned={ dataAccessor.completed } fetchCertificateUrl={ dataAccessor.fetchCertificateUrl } /> }

            { dataAccessor?.prerequisiteData?.locked &&
                <span className="course-details-level-item-status-icon-container status-icon primary">
                    <PaperIcon collection='ultimate' icon='Lock4' />
                </span> 
            
            }

            { !dataAccessor?.prerequisiteData?.locked &&
                <StatusIcon status={ dataAccessor?.status } />
            }

            <LearningItemActionButton dataAccessor={ dataAccessor } classBase={ classBase } isLoading={ isLoading } />
        </div> );
};

LearningListItem.propTypes = {
    dataAccessor: PropTypes.object,
    className: PropTypes.string,
    isLoading: PropTypes.bool,
};

LearningListItem.defaultProps = {
    isLoading: false,
    className: '',
    learningType: '',
    dataAccessor: null,
};

export default LearningListItem;    